/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-07 18:18:24
 * @Description: 
 */

import clsx from "clsx";
import { autorun } from "mobx";
import React from "react";
import FTAnalytic from "src/analyze/FTAnalytic";
import { IconOriginal, IconSuccess } from "src/assets";
import FTScrollbar from "src/components/FTScrollBar/FTScrollBar";
import urls from "src/constant/url";
import { useChoicenessList, useCurrentEffect, useCurrentEffectType, useEffectClassifyMap, useUploadImage } from "src/hooks";
import FTImageStore from "src/store/FTImageStore";
import utils from "src/utils";
import FTLang from "src/utils/FTLang";
import "./ToolLeft.scss";
import "./ToolLeftMobile.scss";

interface IState {
  loading: boolean,
  currentImage: File | null
  currentEffect: any
  effectList: any[]
}

interface IProps {
  className: string
}

export default function ToolLeftMobile(props: IProps) {
  let { className } = props
  let effectClassifyMap = useEffectClassifyMap()
  let choicenessList = useChoicenessList()
  let currentEffect = useCurrentEffect()
  let currentEffectType = useCurrentEffectType()
  let [effectList, setEffectList] = React.useState<any>([])
  let effectRef = React.createRef()
  let classify = React.createRef()

  React.useEffect(() => {
    setEffectList([{title: "choiceness", list: choicenessList}, ...effectClassifyMap])
  }, [effectClassifyMap, choicenessList])

  const setEffectProcess = (i: any, e: any) => {
    if(FTImageStore.currentImage) {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$click_up$goart_project_effects',
        label: {
          resource_id: utils.toFixed(i.id, 0),
          resource_name: i.name,
        }
      })
      FTImageStore.getGoartEffect(i)
      // 如果特效未完全显示，需要使特效完全显示
      let eleRect = e.target.getBoundingClientRect()
      if(eleRect.left + eleRect.width > window.innerWidth) {
        effectRef.current && (effectRef.current as any).scrollMove("right", eleRect.left + eleRect.width * 2 - window.innerWidth)
      }
    }
  }

  const handleOpenImage = async (e: any) => {
    if(e.target && e.target.classList.value.includes("open")) {
      FTImageStore.uploadImage("goart_left_change_image")
    }
  }

  const handleClick = (value: string) => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: value,
        resource_name: value,
      }
    })
    FTImageStore.currentEffectType = value
  }

  return <div className={`toolleft toolleft_mobile ${className}`}>
    <FTScrollbar>
      <div className="toolleft_effect_title">
        {effectList && effectList.map((item: any) => {
          return <span onClick={() => handleClick(item.title)} className={clsx(currentEffectType === item.title && "active")}>
            { item.title === "choiceness" ? FTLang._("goart_choiceness_title") : item.title }
          </span>
        })}
      </div>
    </FTScrollbar>
    <div className="toolleft_effect">
      <div>
        {effectList && effectList.map((i: any) => {
          if(i.title === currentEffectType) {
            return <FTScrollbar onRef={effectRef} className="toolleft_effect_scroll">
              <div className="toolleft_effect_scroll_list">
                {
                  i.list.map((item: any) => {
                  return <div
                      key={item.name}
                      className={`toolleft_effect_item effect${item.id} ${item.name === currentEffect?.name ? "toolleft_effect_item_active" : ""}`}
                      onClick={(e) => setEffectProcess(item, e)}
                    >
                      <div className="toolleft_effect_item_effect">
                        <img src={urls.assetsUrl + item.url} alt={item.name} />
                        <div className="toolleft_effect_item_check">
                          <IconSuccess />
                        </div>
                      </div>
                      <span className="toolleft_effect_item_title">{ item.name}</span>
                    </div>
                  })
                }
              </div>
            </FTScrollbar>
          } else {
            return <></>
          }
      })}
      </div>
    </div>
  </div>
}
